var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCirclesSm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 336,
    width: 336,
    viewBox: "0 0 336 336",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radialGradient-mask",
    cx: "50%",
    cy: "50%",
    r: "50%",
    fx: "50%",
    fy: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "background-pattern-decorative-mask"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    height: "100%",
    width: "100%",
    fill: "url(#radialGradient-mask)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#background-pattern-decorative-mask)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 168,
    r: 168,
    stroke: "#E9EAEB",
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 168,
    r: 144,
    stroke: "#E9EAEB",
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 168,
    r: 120,
    stroke: "#E9EAEB",
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 168,
    r: 96,
    stroke: "#E9EAEB",
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 168,
    r: 72,
    stroke: "#E9EAEB",
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 168,
    r: 48,
    stroke: "#E9EAEB",
    fill: "transparent"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclesSm);
export default __webpack_public_path__ + "static/media/circles-sm.fff0c0fca3aa1fb93739c932b6ef9bf5.svg";
export { ForwardRef as ReactComponent };